import { Link } from 'react-router-dom';
import { Lock, PlayCircle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Progress } from '../ui/progress';

const Stat = ({ label, value, testId }) => (
  <div className="rounded-xl border bg-muted/40 p-4">
    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</p>
    <p className="mt-1 font-heading text-xl font-semibold" data-testid={testId}>{value}</p>
  </div>
);

// Shown until every lesson is done and every assessment passed
export const CertificateLocked = ({ data, coursePath }) => {
  const p = data.progress;
  return (
    <Card className="cert-reveal" data-testid="certificate-locked">
      <CardContent className="p-6 sm:p-10">
        <div className="flex items-center gap-4">
          <div className="rounded-xl bg-amber-100 p-3 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300"><Lock className="h-6 w-6" /></div>
          <div className="min-w-0">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">{data.program}</p>
            <h2 className="truncate font-heading text-2xl font-semibold tracking-tight">Certificate locked</h2>
          </div>
        </div>
        <p className="mt-5 text-muted-foreground" data-testid="certificate-locked-message">
          {p.quiz_count ? data.message : 'Finish every lesson to earn this certificate'} for <span className="font-medium text-foreground">{data.course_title}</span>.
        </p>
        <Progress value={p.overall_progress_percent || 0} className="mt-6 h-2" />
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          <Stat label="Course progress" value={`${p.overall_progress_percent || 0}%`} testId="certificate-locked-progress" />
          <Stat label="Lessons & assessments done" value={`${p.completed_items} of ${p.total_items}`} testId="certificate-locked-items" />
          <Stat label="Assessments passed" value={p.quiz_count ? `${p.quizzes_passed} of ${p.quiz_count}` : 'None in this course'} testId="certificate-locked-quizzes" />
        </div>
        <Button asChild className="mt-8">
          <Link to={coursePath} data-testid="certificate-continue-course"><PlayCircle className="mr-2 h-4 w-4" />Continue course</Link>
        </Button>
      </CardContent>
    </Card>
  );
};
